import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import * as ethers from 'ethers';
import { configJsonState } from "../states/configJsonState";
import { useRecoilState, useRecoilValue } from 'recoil';//取得のみ

import { LoadingModal } from "../components/modal/loadingModalComponent";
import { RulesModal } from "../components/modal/rulesModalComponent";
import {Center,Box,Button,Text,useDisclosure,Image, AlertTitle} from '@chakra-ui/react';
import { mintNFTTopShot } from '../usecases/repositories/topShot';
import { nftJsonState } from '../states/nftJsonState';
import { requestIdState } from '../states/requestIdState';
import { use } from 'i18next';



type Props = {
    buttonText: string,
}


export const AlphaUWalletButton: React.FC<Props> = (props) => {
  const nftJsonStatus = useRecoilValue(nftJsonState);
  const requestId = useRecoilValue(requestIdState);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen:isOpenRulesModal, onOpen:onOpenRulesModal, onClose:onCloseRulesModal } = useDisclosure();
  const btnRef = React.useRef(null);



  const nav = useNavigate();
  const aUWalletButtonStyle: React.CSSProperties = {
    boxSizing: 'border-box',
    width: '254px',
    height: '60px',
    border: '0.5px solid rgba(239, 239, 239, 0.2)',
    boxShadow: 'inset 0px 1px 0px rgba(255, 255, 255, 0.6)',
    marginBottom: '30px',
    borderRadius: '80px',
    transition: 'all 0.5s',
    backgroundColor:'#784296',
    color: 'white',
    fontWeight: 'bold',
    cursor:'pointer',
  };

    


  //αU walletディープリンク用
  const aUWallethandle = async() =>{
    if (window.ethereum && !window.ethereum.isMetaMask) {
      let provider:ethers.ethers.providers.Web3Provider;
      let signer:ethers.ethers.providers.JsonRpcSigner;
      let message = "Connect Wallet";
      let signature:string;
      let walletAddress:string;
      let walletType:string =`metaMask`;
      console.log(`window.ethereum.isMetaMask : ${window.ethereum.isMetaMask}`);

      if (typeof window.ethereum.isMetaMask === "undefined") {
          message = `Connect αU wallet`;
          // walletType = `αU wallet`;
          walletType = `auWallet`;
      }

      try {
          provider = new ethers.providers.Web3Provider(window.ethereum);
          await provider.send("eth_requestAccounts", []);
          signer = provider.getSigner();
          signature = await signer.signMessage(message);
          walletAddress =  await ethers.utils.verifyMessage( message , signature );
      } catch (error) {
          console.log(error);
          return;
      }

      console.log(`getAddress : ${walletAddress}`);
      onOpen();
      const result = await mintNFTTopShot(
        walletAddress,
        walletType,
        requestId,
        nftJsonStatus.nftmeta
      );
      if (result === `6`) {
        nav(`/${result}`,{state:{useWalletAddress:`${walletAddress}`}});
      }else{
        nav(`/${result}`);
      }
    }else{
        console.log(location.href);
        let useDeepLink = window.location.href.replace(`https://`,``).split(`/`);
        console.log(useDeepLink);

        let encodeURL = ``;
        for (let index = 0; index < useDeepLink.length -1; index++) {
            encodeURL += `%2F${useDeepLink[index]}`;
        }

        if (useDeepLink[useDeepLink.length -1].includes(`meta`)) {
            const meta = useDeepLink[useDeepLink.length -1].split(`?meta=`)[1];
            encodeURL += `%2Findex.html%3Fmeta%3D${meta}`;
        }else{
            encodeURL += `%2Findex.html`;
        }
        window.open(`https://alphauwallet.page.link/?link=https://web.wallet.kddi.com/intro.html%3Furl%3Dhttps%3A%2F${encodeURL}&apn=com.kddi.wallet&ibi=com.kddi.wallet&isi=6444401106`);
    }
  }


  React.useEffect(()=>{
    (async() => {

    //   if (window.ethereum) {
    //     onOpenRulesModal();
    //   }

    })();
  },[]);


  return (
    <>
      <div>
          <button 
            className='btn btn-neumo' 
            style={aUWalletButtonStyle} 
            id="btn-aUwallet-getnft" 
            type="button"
            onClick={aUWallethandle}
          >
            &nbsp;{props.buttonText}
          </button>
      </div>

      <LoadingModal 
        isOpen={isOpen} 
        onClose={onClose} 
      />

      {/* 利用規約用モーダル */}
      <RulesModal
        onClose={onCloseRulesModal}
        isOpen={isOpenRulesModal}
        btnRef={btnRef}
      />
    </>
  );
};